/**
 * The microphone, the call speaker and the ring, in the rail.
 *
 * The same panel the dial pad's footer and the mid-call controls row open as a
 * dropdown - one component, three doorways - because the question it answers is
 * the same in all three places and the choice it writes is one set of keys in
 * this browser's storage. What differs is only WHEN it is asked: the dropdowns
 * are opened by somebody who has just discovered a problem, and the rail is
 * where it gets set up before the day starts.
 *
 * ⚠ IT DOES NOT OPEN A MICROPHONE HERE, and that is the reason this wrapper
 * exists rather than an `<AudioPicker liveAudio={null} />` inline in the rail.
 * The panel's level meter captures audio for as long as it is on screen, which
 * inside a dropdown is a few seconds and inside a rail section is the whole
 * working day - Chrome would light the tab's recording dot and hold the device
 * for every operator who left the section open. During a call there is no such
 * cost: the level comes from Twilio's own reading of the stream already being
 * sent, so the bar works exactly when it is worth watching.
 */
import { useT } from "../../../../i18n/I18nProvider";
import { AudioPicker } from "../../../telephony/audio/AudioPicker";
import { useCallContext } from "../../../telephony/CallProvider";

export function RailAudio() {
  const t = useT();
  const call = useCallContext();
  // Called during render on purpose: it reads a ref, and the context value is
  // rebuilt on every phase change - so a call starting or ending swaps the
  // meter's source without this component subscribing to anything of its own.
  const audio = call?.getCallAudio() ?? null;

  return (
    <>
      <div className="crm-msect">{t("calls.audio.label")}</div>
      <AudioPicker liveAudio={audio} capture={false} />
    </>
  );
}
